import { PaginationFooterStyled } from './PaginationFooter.styles';
import { Button } from 'src/components/atoms';
import { Pagination } from '..';

interface Props {
  numPages: number;
  initialPage?: number;
  handlePageClick: (index: number) => void;
  showPagination?: boolean;
  'data-testid'?: string;
  buttons?: {
    left: { text: string; onClick: () => void };
    right: { text: string; onClick: () => void };
  };
  paginationPadding?: string;
  currentPage: number;
}

export const PaginationFooter = ({
  numPages,
  initialPage,
  handlePageClick,
  showPagination,
  buttons,
  paginationPadding,
  currentPage,
  ...props
}: Props) => (
  <PaginationFooterStyled
    showButtons={!!buttons}
    paginationPadding={paginationPadding}
  >
    {buttons && (
      <Button
        variant="secondary"
        onClick={() => {
          buttons?.left.onClick();
          handlePageClick(1);
        }}
        width="120px"
      >
        {buttons.left.text}
      </Button>
    )}
    {showPagination && (
      <Pagination
        numPages={numPages}
        initialPage={initialPage}
        handleClickPage={handlePageClick}
        currentPageNumber={currentPage}
        data-testid={props['data-testid']}
      />
    )}
    {buttons && (
      <Button onClick={buttons.right.onClick} width="120px">
        {buttons.right.text}
      </Button>
    )}
  </PaginationFooterStyled>
);
